var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.passMethod('click')}}},[_c('svg',{staticClass:"iconpark-icon default-icon",class:_vm.classes},[_c('use',{attrs:{"href":("#" + _vm.name)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }